import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useConsentManager } from '../../utils/hooks/useConsentManager'
import { initializeAnalytics as initializeAnalyticsInstance } from 'modules/analytics/analytics'
import useConfig from 'modules/config/state/use-config'
import { useGetAnalyticsSettingsQuery } from 'redux/services/analytics'
import { useEffectOnceWhenReady } from 'utils/hooks/generalUtilHooks'

const useInitializeAnalytics = (isReady: boolean) => {
  const config = useConfig()
  const dispatch = useDispatch()
  const { airgap } = useConsentManager()

  // Query analytics settings
  const analyticsSettings = useGetAnalyticsSettingsQuery({
    campaignId: config.campaignId,
    organizationId: config.organizationId,
  })

  /**
   * Initialize the analytics tools if consent is given and settings are available
   */
  useEffectOnceWhenReady(
    () => {
      initializeAnalyticsInstance({
        dispatch,
        settings: analyticsSettings.data!,
        campaignId: config.campaignId,
        organizationId: config.organizationId,
      })
    },
    [isReady, !!airgap, !!analyticsSettings.data, !!config.campaignId, !!config.organizationId],
    { catch: (error: unknown) => console.error('Failed to initialize analytics tools:', error) },
  )
}

export default useInitializeAnalytics
